import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CTASection from "@/components/CTASection";
import { Star, Facebook, ThumbsUp } from "lucide-react";

interface Review {
  id: number;
  name: string;
  date: string;
  text: string;
}

const reviews: Review[] = [
  {
    id: 1,
    name: "Nikki Bires-Jude",
    date: "Jan 13, 2026",
    text: "The new wood floors completely transformed our cabin. Beautiful craftsmanship, clean work, and attention to detail that truly shows. Couldn't be happier with the result! Highly recommend Big Bear Pro Flooring. Very much appreciated!! 🥰",
  },
  {
    id: 2,
    name: "Christine Trujillo",
    date: "Aug 9, 2025",
    text: "He did an amazing job on my new lvp flooring!! Highly recommend!",
  },
  {
    id: 3,
    name: "Jessica Garcia",
    date: "Jun 29, 2025",
    text: "Big bears pro flooring is amazing and efficient. Needed new flooring in my camper they came out perfect exactly what I wanted. 100% recommend",
  },
  {
    id: 4,
    name: "Shauna Williams",
    date: "Jun 2, 2025",
    text: "He did an amazing job on our floors and worked very hard! He really cares and takes his time to pay attention to details. I would highly recommend!",
  },
  {
    id: 5,
    name: "Darnell Adam",
    date: "Jun 2, 2025",
    text: "Jerry gets the job done amazing price amazing work thank you very much",
  },
];

const Reviews = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-primary py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
              Customer Reviews
            </h1>
            <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto">
              See what our customers have to say about their experience with Big Bear's Pro Floors.
            </p>
          </div>
        </section>

        {/* Reviews Section */}
        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              {/* Facebook Header */}
              <div className="flex items-center justify-center gap-3 mb-4">
                <Facebook className="w-8 h-8 text-accent" />
                <span className="font-heading font-bold text-2xl">Facebook Reviews</span>
              </div>
              
              {/* Rating Summary */}
              <div className="text-center mb-10">
                <div className="flex justify-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 text-accent fill-accent" />
                  ))}
                </div>
                <p className="text-lg font-heading font-bold text-foreground mb-4">
                  100% Recommend (5 Reviews)
                </p>
                <a 
                  href="https://www.facebook.com/profile.php?id=61574755531186&sk=reviews" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-lg font-heading font-bold transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                  View Reviews on Facebook
                </a>
              </div>

              {/* Reviews List */}
              <div className="space-y-6">
                {reviews.map((review) => (
                  <div
                    key={review.id}
                    className="bg-card border border-border rounded-lg p-6 shadow-sm"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                          <span className="font-heading font-bold text-primary-foreground text-lg">
                            {review.name.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-heading font-bold text-foreground">
                            {review.name}
                          </p>
                          <p className="text-sm text-muted-foreground flex items-center gap-2">
                            <ThumbsUp className="w-4 h-4 text-accent" />
                            <span>recommends Big Bear's Pro Floors</span>
                          </p>
                        </div>
                      </div>
                      <span className="text-sm text-muted-foreground">{review.date}</span>
                    </div>
                    <p className="text-foreground leading-relaxed">{review.text}</p>
                  </div>
                ))}
              </div>

              {/* Trust indicators */}
              <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div className="p-6 bg-muted rounded-lg">
                  <div className="text-4xl font-heading font-bold text-accent mb-2">100%</div>
                  <p className="text-muted-foreground">Customer Satisfaction</p>
                </div>
                <div className="p-6 bg-muted rounded-lg">
                  <div className="text-4xl font-heading font-bold text-accent mb-2">Local</div>
                  <p className="text-muted-foreground">Owner-Operated</p>
                </div>
                <div className="p-6 bg-muted rounded-lg">
                  <div className="text-4xl font-heading font-bold text-accent mb-2">Quality</div>
                  <p className="text-muted-foreground">Guaranteed Work</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Reviews;
